import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { BlockProps } from "../../types";
import { useBlockAvailability } from "../../hooks";
import { ContactDetailsBlockSwitch } from "./ContactDetailsBlockSwitch";

export interface ContactDetailsBlockContentProps extends Omit<BlockProps, "info" | "canUpdateObservations"> {
  block: TellescopeModelFromName<"custom_dashboards">["blocks"][number];
  /** Required here because any block type may be selected at runtime, including vitals. */
  canUpdateObservations: boolean;
}

export const ContactDetailsBlockContent = ({ block, className, ...props }: ContactDetailsBlockContentProps) => {
  const { isAvailable } = useBlockAvailability({ isFeatureEnabled: props.isFeatureEnabled });

  if (!isAvailable(block.type)) return null;

  return (
    <div className="flex flex-col flex-1 min-h-0" data-testid="contact-details-block" data-block-type={block.type}>
      <ContactDetailsBlockSwitch block={block} className={className} {...props} />
    </div>
  );
};
